import type { IconKey } from '@/components/ui/iconRegistry'

export type MessengerCard = {
  name: string
  nameFA: string
  color: string
  bgColor: string
  borderColor: string
  /** Registry key for the inline SVG brand glyph rendered white on the card header. */
  iconKey: IconKey
  stat1: { val: number; suf: string; en: string; fa: string }
  stat2: { val: number; suf: string; en: string; fa: string }
  formatsEN: string[]
  formatsFA: string[]
  highlightEN: string
  highlightFA: string
}

export const messengerCards: MessengerCard[] = [
  {
    name: 'Telegram',
    nameFA: 'تلگرام',
    color: '#2AABEE',
    bgColor: 'rgba(42,171,238,0.07)',
    borderColor: 'rgba(42,171,238,0.22)',
    iconKey: 'telegram',
    stat1: { val: 50, suf: 'M+', en: 'Iranian Users', fa: 'کاربر ایرانی' },
    stat2: { val: 3000, suf: '+', en: 'Advertising Channels', fa: 'کانال‌های تبلیغاتی' },
    formatsEN: [
      'Daily Post (Morning)',
      'Evening Post',
      'Reportage / Sponsored',
      'Telegram Ads (Official)',
      'Member Growth (Proxy)',
    ],
    formatsFA: [
      'پست روزانه (صبح)',
      'پست شبانه',
      'رپورتاژ / اسپانسرد',
      'تلگرام ادز (رسمی)',
      'رشد ممبر (پروکسی)',
    ],
    highlightEN:
      'Targeted distribution in high-traffic channels; with broad reach and precise reporting.',
    highlightFA: 'انتشار هدفمند در کانال‌های پربازدید؛ با دسترسی گسترده و گزارش‌گیری دقیق.',
  },
  {
    name: 'WhatsApp',
    nameFA: 'واتساپ',
    color: '#25D366',
    bgColor: 'rgba(37,211,102,0.07)',
    borderColor: 'rgba(37,211,102,0.3)',
    iconKey: 'whatsapp',
    stat1: { val: 40, suf: 'M+', en: 'Iranian Users', fa: 'کاربر ایرانی' },
    stat2: { val: 2500, suf: '+', en: 'Active Channels & Groups', fa: 'کانال و گروه‌های فعال' },
    formatsEN: ['Channel Post', 'Status', 'UTM Link Tracking', 'Group Broadcast'],
    formatsFA: ['پست کانال', 'استاتوس', 'ردیابی لینک UTM', 'پخش گروهی'],
    highlightEN: 'Direct engagement with audiences; in a platform for rapid content sharing.',
    highlightFA: 'تعامل مستقیم‌تر با مخاطبان؛ در بستری برای اشتراک‌گذاری سریع محتوا.',
  },
  {
    name: 'Bale',
    nameFA: 'بله',
    color: '#00B894',
    bgColor: 'rgba(0,184,148,0.07)',
    borderColor: 'rgba(0,184,148,0.22)',
    iconKey: 'bale',
    stat1: { val: 30, suf: 'M+', en: 'Active Users', fa: 'کاربر فعال' },
    stat2: { val: 1000, suf: '+', en: 'Advertising Channels', fa: 'کانال‌های تبلیغاتی' },
    formatsEN: ['Broadcast (CPM)', 'Pin-to-Top CPC', 'Pin-to-Top CPM', 'Pv-to-Pv', 'Bale Ads'],
    formatsFA: ['نشر گسترده (CPM)', 'پین تو تاپ CPC', 'پین تو تاپ CPM', 'Pv-to-Pv', 'بیل ادز'],
    highlightEN: 'Native advertising with broad access to Iranian messengers.',
    highlightFA: 'تبلیغات بومی با دسترسی گسترده در پیام‌رسان ایرانی.',
  },
  {
    name: 'Rubika',
    nameFA: 'روبیکا',
    color: '#794387',
    bgColor: 'rgba(121,67,135,0.07)',
    borderColor: 'rgba(121,67,135,0.2)',
    iconKey: 'rubika',
    stat1: { val: 44, suf: 'M', en: 'Active Users', fa: 'کاربر فعال' },
    stat2: {
      val: 1000,
      suf: '+',
      en: 'Advertising Channels',
      fa: 'کانال‌های تبلیغاتی',
    },
    formatsEN: [
      'Broadcast (CPM)',
      'Pin-to-Top',
      'Pv-to-Pv',
      'Rubino Bloggers',
      'Homepage Banner',
      'Pre-roll Archival',
    ],
    formatsFA: [
      'نشر گسترده (CPM)',
      'پین تو تاپ',
      'Pv-to-Pv',
      'بلاگر روبینو',
      'بنر صفحه اول',
      'پری‌رول آرشیوی',
    ],
    highlightEN: 'Broad access to users in various advertising formats.',
    highlightFA: 'دسترسی گسترده به کاربران در قالب فرمت‌های متنوع تبلیغاتی.',
  },
  {
    name: 'Soroush+',
    nameFA: 'سروش+',
    color: '#2a7a96',
    bgColor: 'rgba(42,122,150,0.07)',
    borderColor: 'rgba(42,122,150,0.2)',
    iconKey: 'soroush',
    stat1: { val: 20, suf: 'M+', en: 'Active Users', fa: 'کاربر فعال' },
    stat2: {
      val: 500,
      suf: '+',
      en: 'Advertising Channels',
      fa: 'کانال‌های تبلیغاتی',
    },
    formatsEN: [
      'Broadcast (CPM)',
      'Pin-to-Top (CPC)',
      'Pv-to-Pv',
      'Pop-up 24h/12h',
      'Push Notification',
      'Vitrin Banner',
    ],
    formatsFA: [
      'نشر گسترده (CPM)',
      'پین تو تاپ (CPC)',
      'Pv-to-Pv',
      'پاپ‌آپ ۲۴/۱۲ ساعته',
      'پوش نوتیفیکیشن',
      'بنر ویترین',
    ],
    highlightEN: 'Broad access to native and high-usage messaging apps.',
    highlightFA: 'دسترسی گسترده در پیام‌رسانی بومی و پرکاربر.',
  },
  {
    name: 'Eitaa',
    nameFA: 'ایتا',
    color: '#EF7F1A',
    bgColor: 'rgba(239,127,26,0.07)',
    borderColor: 'rgba(239,127,26,0.22)',
    iconKey: 'eitaa',
    stat1: { val: 40, suf: 'M+', en: 'Active Users', fa: 'کاربر فعال' },
    stat2: { val: 700, suf: '+', en: 'Advertising Channels', fa: 'کانال‌های تبلیغاتی' },
    formatsEN: ['Broadcast (CPM)', 'Pin-to-Top National', 'Pin-to-Top Provincial', 'CPM Targeting'],
    formatsFA: ['نشر گسترده (CPM)', 'پین تو تاپ سراسری', 'پین تو تاپ استانی', 'هدف‌گیری CPM'],
    highlightEN: 'Access to diverse audiences in a native and widespread environment.',
    highlightFA: 'دسترسی به مخاطبان متنوع در بستری بومی و فراگیر.',
  },
]
